import { render, staticRenderFns } from "./EquipmentTransferViewGlobal.vue?vue&type=template&id=2ab8b1e0"
import script from "./EquipmentTransferViewGlobal.vue?vue&type=script&lang=js"
export * from "./EquipmentTransferViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports